/**
 * PageWrapper - responsive page layout container
 */
import React from 'react';
import { cn } from '@/utils/cn';
import { tokens } from '@/theme/tokens';

interface PageWrapperProps {
  children: React.ReactNode;
  className?: string;
  maxWidth?: 'shell' | '4xl' | '5xl' | '6xl' | '7xl' | 'full';
  padded?: boolean;
}

const MAX_WIDTH_MAP: Record<string, string> = {
  shell: tokens.layout.shell,
  '4xl': 'max-w-4xl',
  '5xl': 'max-w-5xl',
  '6xl': 'max-w-6xl',
  '7xl': 'max-w-7xl',
  full: 'max-w-full',
};

export const PageWrapper: React.FC<PageWrapperProps> = ({
  children,
  className = '',
  maxWidth = 'shell',
  padded = false,
}) => {
  const maxWidthClass = MAX_WIDTH_MAP[maxWidth] || tokens.layout.shell;
  return (
    <div
      className={cn(
        'w-full mx-auto',
        maxWidthClass,
        padded && 'px-4 sm:px-6 lg:px-8',
        className,
      )}
    >
      {children}
    </div>
  );
};
